import accounts from './accounts'
import bookingDetails from './bookingDetails'
import bookings from './bookings'
import bookingTransactions from './bookingTransactions'
import damageBlueprints from './damageBlueprints'
import damageChecks from './damageChecks'
import damageReports from './damageReports'
import events from './events'
import hubs from './hubs'
import incidentReportComments from './incidentReportComments'
import opsUsers from './opsUsers'
import organisationDetails from './organisationDetails'
import organisationPressures from './organisationPressures'
import organisations from './organisations'
import paymentActions from './paymentActions'
import pricingStrategies from './pricingStrategies'
import userDetails from './userDetails'
import userGroups from './userGroups'
import users from './users'
import vehicleDetails from './vehicleDetails'
import vehicleGroups from './vehicleGroups'
import vehicles from './vehicles'
import vehicleTelematics from './vehicleTelematics'
import vehicleUnavailabilities from './vehicleUnavailabilities'
import vouchers from './vouchers'

const resources = [
  // order determines menu order!
  organisations,
  users,
  userGroups,
  vehicles,
  vehicleGroups,
  bookings,
  vehicleUnavailabilities,
  // timelineView: vehicles,
  vouchers,
  damageReports,
  vehicleTelematics,
  events,
  // resources below this line are not in the menu
  accounts,
  bookingDetails,
  bookingTransactions,
  damageBlueprints,
  damageChecks,
  hubs,
  incidentReportComments,
  opsUsers,
  organisationDetails,
  organisationPressures,
  paymentActions,
  pricingStrategies,
  userDetails,
  vehicleDetails,
]

export const getResourceByName = (name) => resources.find((r) => r.name === name)

export default resources
